import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';
import {CATEGORIES_COLUMN, Columns} from "./CAtegoriesColumn";
import DataTableLayout from "./DataTableLayout";
import MOCK_DATA from './MOCK_DATA.json';
import SimpleDataTable from "./SimpleDataTable";
import CustomImage from "./CustomImage";
import CustomEditModal from "../IncidentsLog/CustomEditModal";
import {useFormik} from "formik";
import * as yup from 'yup';
import axios from "axios";
import {toast, ToastContainer} from "react-toastify";
import {BASE_URL} from '../../config.json'
import ENUMS from "../../utils/ENUMS";
import {getAuthData, setAuth} from "../../services/authService";

const token = localStorage.getItem(ENUMS.AUTH);
const auth = getAuthData();
const config = {
    headers: {Authorization: `Bearer ${token}`}
};
const validationSchema = yup.object().shape({
    label: yup
        .string(),
});

const customStyles = {
    overlay: {
        zIndex: '2',
        backgroundColor: 'rgba(0,0,0,0.6)',

    },
    content: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        // width:"60%",
        overflow:'auto'

    },
};
const customStyles2 = {
    overlay: {
        zIndex: '3',
        backgroundColor: 'rgba(0,0,0,0.6)',

    },
    content: {
        position: 'absolute',
        top: '30%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',

    },
};
const customStyles3 = {
    overlay: {
        zIndex: '3',
        backgroundColor: 'rgba(0,0,0,0.6)',

    },
    content: {
        position: 'absolute',
        top: '30%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        gap: '10px',
    },
};
Modal.setAppElement("#root");


// incident function start

const IncidentReport = () => {

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalDel, setModalDel] = useState(false);
    const [modaledit, setmodaledit] = useState(false);
    const [delUserData, setDelUserData] = useState();
    const [CourseError, SetCourseError] = useState();
    const [incidentData,setIncidentData] = useState([])
    const [loadingIncident,setLoadingIncident] = useState(true)
const [incidentId,setIncidentId] = useState()
    const initialValues = {
        label: '',

    };
//

    // useEffect(() => {
    //     document.body.style.overflow = 'hidden';
    //     return ()=> document.body.style.overflow = 'unset';
    // }, []);



    useEffect(() => {
    },[incidentData]);

     const postIncident = (data, showToast = true) => {
        const finalData={
            label:data.label,
            club:auth.club_id
        }
        // if (data.label.length==='')
        // {
        //     console.log("length is empty")
        // }
        axios.post(`${BASE_URL}/club/incident_create/`, finalData, config)
            .then(res => {
                    toast.success("Incident created successfully");
                openModalRun()
                }
            ).catch((err) => {
            console.log(err, 'err')
            toast.error(err.response.data.errMsg);

        })
    }

    const [Formlist, SetFormList] = useState(initialValues)


    const modalHandler = () => {
        setModalIsOpen(false)
initialValues.label=''
    }
    const openModalRun = () => {
        setModalIsOpen(true)
        axios.get(`${BASE_URL}/club/incident_type/${auth.club_id}/`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
        })
            .then(res => {
                // SetHoles(res.data.data);
                setIncidentData(res.data.data)
                setLoadingIncident(false)


            })
            .catch(err => {
                console.log(err)
            })


    }
    const formik = useFormik({
        initialValues: {
            label: '',
        },
        onSubmit: (values, {resetForm}) => {
            values.label = values.label.toLowerCase();
            postIncident(values)
            resetForm()
        },
        validationSchema: validationSchema,

    });

    const deleteIncident = (data) => {
        setModalDel(true)
        setDelUserData(data.incident_id)
    }
    const editIncident = (data) => {
        setmodaledit(true)
        setIncidentId(data.incident_id)
        Formlist.label = data.incident
    }
    const removeIncident = (id) => {
        axios.delete(`${BASE_URL}/club/incident_details/${id}/`, {
            headers: {
                Authorization: `Bearer ${token}`
            },

        }).then(res => {
            if (res.status == 200) {
                // setShowModal(false);
                toast.success("Incident Deleted SuccessFully");
                openModalRun()

            } else {
                toast.error("Unable to  Delete");

            }

        })
            .catch(err => {
                // alert('Something Wents Wrong Please Give Proper details')
                console.log(err)
            })
        setModalDel(false)

    }
    const updateincident = (e) => {
        SetFormList({
            label: e.target.value
        })
    }
    const updateIncidentfinal = () => {
        if (Formlist.label === "" || Formlist.label === undefined) {
            SetCourseError("* Incident is required");
        }else {
            axios.patch(`${BASE_URL}/club/incident_details/${incidentId}/`, Formlist, config)
                .then(res => {
                        toast.success("Incident updated successfully");
                    setmodaledit(false)
                        openModalRun()
                    }
                ).catch((err) => {
                console.log(err, 'err')
                toast.error(err.response.data.errMsg);

            })
        }
    }
    const renderCell = (cell) => {
        if (cell.column.id === 'edit') {

            return (
                <span
                    className='asc__cell cell--edit'
                >

                       <img src={require("../../assets/edit.svg").default} alt=""
                            onClick={() => editIncident(cell.row.original)} style={{cursor: "pointer",width:"2rem"}}

                       />

                    {cell.render('Cell')}
                </span>
            )

        }

        if (cell.column.id === 'delete') {

            return (
                <span
                    className='asc__cell cell--delete'
                >

                <img src={require("../../assets/images/del/delete.svg").default} alt=""

                     onClick={() => deleteIncident(cell.row.original)} style={{cursor: "pointer"}}
                    // onClick={() => console.log(cell.row.original, "delete")} style={{cursor: "pointer"}}

                />

                </span>
            )

        }

        return cell.render('Cell');
    }


    return (
        <div className="incident__report-modal">
            <ToastContainer/>

            <button className="res-btn-primary" onClick={openModalRun}>Add Incident Type</button>

            <Modal
                isOpen={modalIsOpen}
                style={customStyles}
                contentLabel="Example Modal"
                className={"incident_list"}

            >
                <div className="incident__modal">
                    <button target="_self" className="modal-content--cross">
                        <img src={require("../../../src/assets/images/cross/Group 6926.svg").default} alt=""
                             onClick={modalHandler}/>

                    </button>
                    <h1 className="text-jost-sb-24">Incident </h1>
                    <form className="report_Form"
                          onSubmit={formik.handleSubmit}
                    >
                        <input
                            className="form__input-md-wt"
                            type="text"
                            placeholder={"Incident Name"}
                            {...formik.getFieldProps('label')}
                        />
                        <button type="submit" className="res-btn-lightgrn">Add</button>
                    </form>
                    <div className="reports_table">

                        {loadingIncident?
                            <span>Loading Incidents...</span>:
                            <DataTableLayout
                            showNoResultsMsg={true}
                            noResultsMsgLabel='No Incident available!'
                            columns={Columns}
                            data={incidentData}
                            className='asc__dt'
                            renderCell={renderCell}

                        />}

                    </div>
                </div>
            </Modal>


            <Modal
                isOpen={modalDel}
                style={customStyles2}
                contentLabel="Example Modal"

            >
                <h2 className=" text-jost-sb-20"> Are you sure you want to delete this incident? </h2>
                <div style={{display: "flex", justifyContent: "flex-end"}}>

                    <button                                    className="res-btn-primary"
                    
 onClick={() => setModalDel(!modalDel)}>
                        Cancel
                    </button>

                    <button                                     className="res-btn-lightgrn"

 onClick={() => removeIncident(delUserData)}>
                        Confirm
                    </button>
                </div>

            </Modal>


            <Modal
                isOpen={modaledit}
                style={customStyles3}
                contentLabel="Example Modal"

            >
                <h2 className=" text-jost-sb-20"> Edit incident </h2>
                {/*<Modal.Title style={{padding: "1rem 0"}} className="text-jost-sb-19">EDIT INCIDENT</Modal.Title>*/}
                <input className="acc__input-lg" type="text" placeholder='Incident'
                       name="course_name"
                       onChange={updateincident}
                       value={Formlist.label}
                       required/>
                {Formlist.label === '' || Formlist.label === undefined ? (
                    <h1 style={{color: 'red', fontSize: '1.3rem'}}>{CourseError}</h1>) : ''}
                <div style={{display: "flex", justifyContent: "flex-end",gap:'2rem',marginTop:'1.5rem'}}>

                    <button className="res-btn-primary" onClick={() => setmodaledit(!modaledit)}>
                        Cancel
                    </button>

                    <button  className="res-btn-lightgrn" onClick={updateIncidentfinal}>
                        update
                    </button>
                </div>

            </Modal>
        </div>
    );
};

export default IncidentReport;
